/**
 * A spectacular, oversized editorial display of "Black Dollars United" —
 * outlined gold serif letters that scroll with the page, wrapped by a thin
 * hairline divider and a "One Trillion Dollar Spending Power" subtext.
 */
export default function BrandStatement() {
  return (
    <section className="relative py-24 sm:py-32 border-y border-bdu-gold/10 overflow-hidden" data-testid="brand-statement">
      {/* Subtle background echo */}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.04]">
        <span
          className="font-serif whitespace-nowrap"
          style={{
            fontSize: "26vw",
            color: "#D4AF37",
            letterSpacing: "-0.04em",
            fontStyle: "italic",
          }}
          aria-hidden="true"
        >
          BDU
        </span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-10">
        <div className="flex items-center gap-4 justify-center">
          <span className="h-px w-16 bg-bdu-gold/40" />
          <span className="label-eyebrow">Est. 2026 · Pan-African</span>
          <span className="h-px w-16 bg-bdu-gold/40" />
        </div>

        <h2
          className="mt-10 font-serif text-center leading-[0.85] tracking-tight"
          style={{
            fontSize: "clamp(3.5rem, 12vw, 12rem)",
            fontWeight: 400,
          }}
          data-testid="brand-statement-heading"
        >
          <span className="block text-bdu-cream">Black</span>
          <span
            className="block italic"
            style={{
              WebkitTextStroke: "1.5px #D4AF37",
              color: "transparent",
              letterSpacing: "-0.03em",
            }}
          >
            Dollars
          </span>
          <span className="block text-bdu-gold">United</span>
        </h2>

        <div className="mt-14 flex flex-col items-center gap-6">
          <div className="h-px w-24 bg-bdu-gold" />
          <p className="max-w-2xl text-center text-bdu-cream/70 text-base sm:text-lg leading-relaxed">
            One trillion dollars of spending power. One fund. One people. We circulate the dollar
            back into the hands that built America — and we do it together.
          </p>
        </div>
      </div>
    </section>
  );
}
